import React from 'react';
import './index.css';
import { useHistory } from "react-router-dom";
import { useMenuStore } from '../../../store';
import { API_DOC_URL, CONSOLE_URL } from '../../../const/constants.js';


export default ({
  onChangeAction
}) => {
  const history = useHistory();
  
  // 从 store 获取当前菜单和折叠状态
  const currentMenu = useMenuStore(state => state.currentMenu);
  const isMenuCollapsed = useMenuStore(state => state.isMenuCollapsed);
  
  // 从 store 计算派生状态
  const isActive = !isMenuCollapsed;
  
  const relatedTitle = currentMenu?.relatedTitle || [];
  const action = currentMenu?.action;
  const title = currentMenu?.title;
  const apiUrl = currentMenu?.url || API_DOC_URL;
  const consoleUrl = currentMenu?.consoleUrl || CONSOLE_URL;

  const RelatedTitleCom = () => {
    let com = <></>
    if(relatedTitle.length > 0){
      com = <div className="relatedTitle-container">
      {
        relatedTitle.map(item => (
          <div onClick={() => {
            history.push({search: `action=${item.action}`})
            onChangeAction && onChangeAction(item.action)
          }}
          className={`relatedTitle-item ${action === item.action ? 'isActive' : ''}`}>{item.title}</div>
        ))
      }
      </div>
    }else{
      com = <>
      {
         title && <div className="ocrDemo-header__title">{title}</div>
      }
      </>
    }
    return com
  }
  return (
    <div className="ocrDemo-header-container">
<div className={`ocrDemo-header__logo-container ${ isActive ? 'isActive' : ''} ${ action ? 'border' : ''}`}>
        <div className={`ocrDemo-header__logo ${ isActive ? 'isActive' : ''}`} onClick={() => window.open('https://ocrdemo.cloud.tencent.com/', '_self')}></div>
      </div>
      {
        RelatedTitleCom()
      }
      <div className="ocrDemo-header__navItem">
        <span className="ocrDemo-header__logo-api"></span>
        <a href={apiUrl} target="_blank" className="ocrDemo-header__navItem-title">API文档</a>
      </div>
      <div className="ocrDemo-header__navItem">
        <span className="ocrDemo-header__logo-console"></span>
        <a href={consoleUrl} target="_blank" className="ocrDemo-header__navItem-title">控制台</a>
      </div>
    </div>

  );
};